<template>
  <div>
    <!-- Card component from coreUI -->
    <CRow>
      <transition appear name="slide" type="animation">
        <CCol lg="3" md="6" v-for="(outterItem, index) in data" :key="index">
          <CCard
            @mouseover="outterItem.active=true"
            @mouseleave="outterItem.active=false"
            :class="['CCardTemplate', { 'card-active': outterItem.active || outterItem.completed ||outterItem.isOpen}]"
          >
            <CCardHeader class="CCardHeaderTemplate pb-0">
              <CRow>
                <CCol
                  sm="12"
                  class="titleText card-title"
                >{{ outterItem.courseTitle }}</CCol>
                <!--
              <CCol sm="4" class="radial-height">
                <radial-menu
                  @click="checklib(index)"
                  ref="radialMenu"
                  style="background-color: white;"
                  :itemSize="36"
                  :rotate="230"
                  :radius="70"
                  :angle-restriction="-120"
                >
                  <radial-menu-item
                    v-for="(item, index) in outterItem.menu"
                    :key="index"
                    style="background-color: white;"
                    @click="test(outterItem.menu[index])"
                  >
                    <span :style="{ color: item.color }">
                      <i :class="item.icon" />
                    </span>
                  </radial-menu-item>
                </radial-menu>
                </CCol>-->
              </CRow>
              <!-- <div class="row">-->
              <!--							<div class="col titleText">-->
              <!--								{{ outterItem.courseTitle }}-->
              <!--							</div>-->
              <!--							<div>-->
              <!--								<radial-menu-->
              <!--									style="margin: auto; margin-top: 300px; background-color: white"-->
              <!--									:itemSize="36"-->
              <!--									:rotate="195"-->
              <!--									:radius="96"-->
              <!--									:angle-restriction="-90"-->
              <!--								>-->
              <!--									<radial-menu-item-->
              <!--										v-for="(item, index) in outterItem.menu"-->
              <!--										:key="index"-->
              <!--										style="background-color: white"-->
              <!--									>-->
              <!--										<span :style="{ color: item.color }">-->
              <!--											<i :class="item.icon" />-->
              <!--										</span>-->
              <!--									</radial-menu-item>-->
              <!--								</radial-menu>-->
              <!--							</div>-->
              <!--						</div> -->
            </CCardHeader>
            <CCardBody class="column p-0">
              <div class="card-body pt-0">
                <CRow>
                  <CCol
                    sm="12"
                    class="text-white text-left font-weight-bolder font-xl"
                  >{{ outterItem.name.first }} {{ outterItem.name.last }}</CCol>
                </CRow>
                <CRow>
                  <CCol sm="6" class="text-white text-left">Study hours:</CCol>
                  <CCol sm="6" class="text-white text-right">{{ outterItem.studyHours }}</CCol>
                </CRow>
                <CRow v-for="(category,index) in outterItem.categories" :key="index">
                  <CCol sm="6" class="text-left text-white">
                    <label v-if="index == 0">Category</label>
                  </CCol>
                  <CCol class="text-white text-right">{{ category.name }}</CCol>
                </CRow>
                <CRow>
                  <CCol sm="6" class="text-white text-left">Views:</CCol>
                  <CCol sm="6" class="text-white text-right">{{ outterItem.views }}</CCol>
                </CRow>
              </div>
              <!-- Condition -->
              <!-- v-if="outterItem.active && outterItem.status.enroll && !outterItem.completed" -->
              <!--
            <CRow
              class="card-body pb-0 pt-0"
              v-if="outterItem.isOpen || (outterItem.active && outterItem.status.enroll && !outterItem.completed)"
            >
              <CCol sm="8">
                <CProgress
                  :value="outterItem.status.progress"
                  :max="outterItem.status.max"
                  class="progressBar"
                  show-value
                  border-radius="20%"
                >
                  <CProgressBar style="border-radius:20px"></CProgressBar>
                </CProgress>
              </CCol>
              <CCol sm="4">
                <CButton class="playButton" color="primary" @click="testNav(outterItem.navigate)">
                  <span style="color: red;">
                    <i class="fas fa-caret-right" style="playSign"></i>
                  </span>
                </CButton>
                <button
                  type="button"
                  class="btn btn-default btn-circle btn-lg"
                  style="border-color:white"
                  @click="testNav(outterItem.navigate)"
                >
                  <span style="color: red; padding-bottom:12px">
                    <i class="fas fa-caret-right fa-2x"></i>
                  </span>
                  <span>
                    <i class="fas fa-circle-thin fa-caret-right fa-2x"></i>
                  </span>
                </button>
              </CCol>
            </CRow>
           
            <div v-else-if=" outterItem.completed">
              <CProgress
                :value="outterItem.status.progress"
                :max="outterItem.status.max"
                class="mb-3 progressBar"
                show-value
              />
              <div class="imgCompleted"></div>
            </div>
              -->
              <!-- When user hover and not enter the course yet -->
              <!-- <CRow
              v-if="outterItem.active==true || outterItem.completed || outterItem.isOpen"
              class="card-body pt-0"
            >
              <CCol sm="12" v-if="outterItem.status.enroll === false">
                <div v-if="outterItem.completed" class="emptyBottom"></div>
                <div v-else>
                  <CButton
                    block
                    class="border-0 button-overview"
                    color="primary"
                    @click="outterItem.status.enroll = !outterItem.status.enroll"
                  >Overview</CButton>
                </div>
              </CCol>
              </CRow>-->
            </CCardBody>
          </CCard>
        </CCol>
      </transition>
    </CRow>
    <!-- ------------------------------------------------------------Cmodal-------------------------------------------------------------- -->

    <CModal
      add-content-classes="bg-transparent border-0 pl-5"
      :no-close-on-backdrop="true"
      :centered="true"
      :show.sync="isVisible"
      @click="onPressUnenrollModal()"
      :closeOnBackdrop="false"
    >
      <template #header-wrapper>
        <div class="closeBtnContainer" @click="isVisible=false">
          <p class="closeButton">
            <img
              src="@/assets/icons/closeButton.svg"
              style="background-color: white; border-radius: 50%;"
            />
          </p>
        </div>
      </template>
      <template #footer-wrapper>
        <div></div>
      </template>
      <template #body-wrapper>
        <div class="modal-content tab widthLoginModal">
          <div class="modal-text">
            <div class="p-3 mt-1">
              <b
                style="color:black;
              font: Bold 22px/32px Roboto;
              letter-spacing: 0px;
              opacity: 1;
              margin-bottom: 0px;
              margin-top: 20px
                "
              >Are you sure you want to unenroll from</b>
              <br />
              <h3
                style="color: #BD2531
              font: Bold 24px/32px Roboto;
              letter-spacing: 0px;
              color: #BD2531;
              opacity: 1;
              margin-bottom: 0px;
              margin-top: 20px
              margin-left: 125px;
              margin-left:125px;
              "
              >CHINESE 1</h3>
              <br />
              <div style="text-align:center">
                <p
                  style="margin-bottom:0pxtext-align: left;
                font: Bold 14px/19px Roboto;
                letter-spacing: 0px;
                color: #000000;
                opacity: 1;
                
                "
                >Your feedback helps MDL improve</p>
                <p
                  style="margin-bottom:0pxtext-align: left;
                font: Bold 14px/19px Roboto;
                letter-spacing: 0px;
                color: #000000;
                opacity: 1;"
                >Please tell us why you're unenrolling (optional)</p>
              </div>
              <br />

              <select name id class="drobdown_modal">
                <option
                  value
                  disabled
                  selected
                  style="opacity: 1;font-size: 16px;"
                >Select your reason for Unenrolling</option>
                <option value="I don't like the course">I don't like the course</option>
                <option value="The course was too hard">The course was too hard</option>
                <option value="The course was too easy">The course was too easy</option>
                <option value="Didn't meet expectations">Didn't meet expectations</option>
                <option value="I prefer not to say">I prefer not to say</option>
                <option value="Other">Other</option>
              </select>
              <br />
              <br />
              <div style="display: flex;flex-direction: row;justify-content: center;">
                <CButton
                  color="secondary"
                  class="button"
                  style="background-color: gray;"
                  @click="isVisible=false"
                >CANCEL</CButton>
                <CButton
                  color="secondary"
                  class="button"
                  style="background-color: dodgerblue;"
                  @click="isVisible= false"
                >UNENROLL</CButton>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CModal>
    <!-- ------------------------------------------------------------Cmodal-------------------------------------------------------------- -->
  </div>
</template>
<script>
import { RadialMenu, RadialMenuItem } from "vue-radial-menu";
// import UserService from '../../service/Api';
export default {
  name: "Login",
  myModal: false,
  components: {
    RadialMenu,
    RadialMenuItem,
  },
  data() {
    return {
      dialog: {
        message: "",
        status: false,
      },
      isVisible: false,
      data: [
        {
          active: false,
          isOpen: true,
          name: {
            first: "Full",
            last: "Name",
          },
          courseTitle: "NM",
          backgroundColor: "fff",
          categories: [
            {
              name: "Category 1",
            },
          ],
          favorite: {
            status: false,
          },
          status: {
            enroll: false,
            progress: 50,
            max: 100,
          },
          studyHours: 10,
          completed: false,
          views: 0,
          navigate: "To chncourse",
          overviewNav: "To overview page",
          menu: [
            /*
            {
              name: "unenroll",
              status: false,
              color: "red",
              icon: "fas fa-ban",
            },
            {
              name: "Shared",
              status: false,
              color: "blue",
              icon: "fas fa-eye",
            },
            {
              name: "Flag",
              status: false,
              color: "blue",
              icon: "fas fa-flag",
            },
            {
              name: "View",
              status: false,
              color: "blue",
              icon: "fas fa-share-square",
            },
            {
              name: "Favourite",
              status: false,
              color: "blue",
              icon: "fas fa-star",
            },
            */
            {
              name: "star",
              status: false,
              color: "gray",
              active: require("@/assets/icons/cardMenu/favorite.svg"),
              nonActive: require("@/assets/icons/cardMenu/non-favorite.svg"),
              icon: "fas fa-star",
            },
          ],
        },
        // {
        //   active: false,
        //   isOpen: false,
        //   name: {
        //     first: "Hi",
        //     last: "There"
        //   },
        //   courseTitle: "NM",
        //   backgroundColor: "fff",
        //   categories: [
        //     {
        //       name: "Category 1"
        //     },
        //     {
        //       name: "Category 2"
        //     }
        //   ],
        //   favorite: {
        //     status: false
        //   },
        //   status: {
        //     enroll: false,
        //     progress: 100,
        //     max: 100
        //   },
        //   studyHours: 10,
        //   completed: true,
        //   views: 0,
        //   navigate: "To chncourse",
        //   overviewNav: "To overview page",
        //   menu: [
        //     {
        //       name: "favorite",
        //       status: false,
        //       color: "gray",
        //       icon: "fas fa-ban"
        //     },
        //     {
        //       name: "Shared",
        //       status: false,
        //       color: "gray",
        //       icon: "fas fa-eye"
        //     },
        //     {
        //       name: "Flag",
        //       status: false,
        //       color: "gray",
        //       icon: "fas fa-flag"
        //     },
        //     {
        //       name: "View",
        //       status: false,
        //       color: "gray",
        //       icon: "fas fa-share-square"
        //     },
        //     {
        //       name: "Favourite",
        //       status: false,
        //       color: "gray",
        //       icon: "fas fa-star"
        //     }
        //   ]
        // }
      ],
      // status
      username: "ping@.com",
      password: "",
      dialog: {
        color: "info",
        status: false,
        message: "Hello",
      },
      loremIpsum:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.",
    };
  },
  mounted: function () {
    let i;
    for (i = 0; i < this.data.length; i++) {
      this.$refs.radialMenu[i].$el.querySelector(
        ".vue-radial-menu-container"
      ).innerHTML = "...";
      this.$refs.radialMenu[i].$el.querySelector(
        ".vue-radial-menu-container"
      ).style.paddingBottom = "32px";
      this.$refs.radialMenu[i].$el.querySelector(
        ".vue-radial-menu-container"
      ).style.paddingLeft = "3px";
      this.$refs.radialMenu[i].style.transform = "none";
    }
  },
  methods: {
    testNav: function (nav) {
      alert(nav);
    },
    test(test) {
      if (test.name == "unenroll") {
        this.onPressUnenrollModal();
      }
    },
    onPressUnenrollModal() {
      this.isVisible = true;
      // alert(this.isVisible);
    },
    // checklib(index) {
    //   this.data[index].isOpen = !this.$refs.radialMenu[index].isOpen;
    // }
    // ใช้เปิดปิด แทบด้านล่าง การแสดงโปรเกส
  },
};
</script>
<style scoped>
.hvr-grow {
    display: inline-block;
    vertical-align: middle;
    transform: translateZ(0);
    box-shadow: 0 0 1px rgba(0, 0, 0, 0);
    backface-visibility: hidden;
    -moz-osx-font-smoothing: grayscale;
    transition-duration: 0.3s;
    transition-property: transform;
}

.hvr-grow:hover,
.hvr-grow:focus,
.hvr-grow:active {
  transform: scale(1.03);
  margin-right: 2em;
}
.radial-height {
  height: 2rem;
  /* height: auto;
  width: 2rem; */
}
.emptyBottom {
  margin-top: 33px;
}
.imgCompleted {
  position: absolute;
  width: 121px;
  height: 121px;
  bottom: 5%;
  right: 5%;
  background: black;
  opacity: 0.5;
  border-radius: 50px;
  z-index: -1;
}
.vue-radial-menu-wrapper {
  margin: 0 !important;
  background-color: white !important;
  border-bottom-left-radius: 40px !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 40px;
  border-bottom-right-radius: 0 !important;
  width: 100% !important;
  height: 100% !important;
}
/* MDL Card styles */
.titleText {
  font-size: 5rem;
  font-weight: bold;
  margin-top: 0.5rem;
  color: white;
}
.nameText {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 1rem;
  color: white;
}
.detailTextLeft {
  float: left !important;
  /* margin-left: 0.rem; */
  color: white;
}
.detailTextRight {
  float: right !important;
  color: white;
}
.CCardTemplate {
  position: relative;
  width: 260px;
  height: 324px;
  border-radius: 40px;
  background-color: #2a4388;
  margin-top: 0rem;
  background-repeat: no-repeat;
  background-size: 120px;
  box-shadow: 5px 5px 10px #0000004d;
  border-radius: 40px;
}
.CCardHeaderTemplate {
  border: 0px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background: transparent;
}
.overviewButton {
  border-radius: 20px;
  background: white;
  width: 100%;
  height: 2.4rem;
  margin-top: 1rem;
}
.progressBar {
  height: 39px;
  border-radius: 50px;
  box-shadow: none;
  padding: 5px;
  overflow: visible;
  width: 165px;
}
.playButton {
  border-radius: 50%;
  height: 2rem;
  width: 36px;
  background-color: white;
  align-items: center;
  border: 1px solid white;
}
.cardMenu {
  border-top-right-radius: 50%;
  border-bottom-left-radius: 50%;
}
/* .CCardTemplate:hover {
	background: red;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
} */
/* .card:hover {
	background-color: blue;
} */
/* .card-active {
  background-color: blue;
} */
.card{
  transition: transform 0.2s;
}
.content {
  margin-bottom: 1.5 rem !important;
}
.card-header {
  padding-right: 0rem;
  padding-top: 0rem;
  padding-left: 1rem;
  margin-bottom: 0;
}
.button-overview {
  color: blue;
  background-color: white;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
}
.card-body {
  -ms-flex: 1 1 auto;
  -webkit-box-flex: 1;
  flex: 1 1 auto;
  min-height: 1px;
  padding-bottom: 1.25rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  z-index: 1;
}
.btn-circle.btn-lg {
  width: 40px;
  height: 40px;
  font-size: 18px;
  line-height: 1.33;
  border-radius: 25px;
  background-color: white;
  color: red;
  padding: 0;
  padding-left: 5px;
  margin-left: 20px;
}
.svg-inline--fa fa-caret-right fa-w-6 fa-2x {
  margin-left: 5px;
  padding-bottom: 4px;
}
/* CSS modal */
/* -- ---------------------------------------------------------- CSS MODAL -------------------------------------------------- -- */

.closeButton {
  align-content: flex-end;
  float: right;
  width: 26px;
  height: 26px;
  padding-top: -100px;
  margin-right: 12px;
  cursor: pointer;
  margin-bottom: 0.1em;
}

.button {
  outline: none;
  border: none;
  width: 12rem;
  text-align: center;
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 40px;
  font-size: 16px;
  margin: 10px;
}

.drobdown_modal {
  width: 90%;
  border: 0px;
  border-bottom: 1px solid #cccccc;
  margin-left: 20px;
}

.modal-text p {
  font-weight: 300;
  font-size: 16px;
  color: black;
  margin-bottom: 0px;
}

.modal-text h1 {
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  font-size: 24px;
  color: black;
  text-align: center;
}

.modal-content p {
  font-size: 24px;
  margin-top: 0.6em;
}

.tab {
  border-top-right-radius: 30px;
  border-top-left-radius: 30px;
  border-bottom-right-radius: 30px;
  border-bottom-left-radius: 30px;
}

.widthLoginModal {
  width: 420px;
  position: inherit;
}
</style>